import { Authenticator } from "totalinvoice-frontend-core"
import { config } from "./Config"
import { requestDelay } from "./Utils"

const errorResult = {
    status: "failed",
    errorCode: null, // hide error code by default
    message: "The server encountered an internal error or misconfiguration and was unable to complete your request."
}

const successResult = {
    status: "ok",
    errorCode: 0,
    message: null,
    data: null
}

function buildRequest(postBody = null) {
    return {
        method: postBody ? "POST" : "GET", // *GET, POST, PUT, DELETE, etc.
        //mode: 'no-cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: new Headers({
          "Accept": "application/json",
          "Authorization": `Bearer ${Authenticator.getToken()}`,
          "Content-type": "application/json"
        }),
        //redirect: 'follow', // manual, *follow, error
        //referrerPolicy: 'no-referrer',
        body: postBody ? JSON.stringify(postBody) : null
    }
}

export async function fetchJSON(apiPath, postBody = null) {
    const request = buildRequest(postBody)

    let result
    try {
        const response = await fetch(config.backend_url + apiPath, request)

        if (response.status === 200) {
            result = await response.json()
        } else {
            result = { ...errorResult, errorCode: response.errorCode }
        }
    } catch (e) {
        //console.error(e)
        result = errorResult
    }

    await requestDelay()

    return result
}

export async function fetchBlob(apiPath, postBody = null) {
    const request = buildRequest(postBody)

    let result
    try {
        const response = await fetch(config.backend_url + apiPath, request);

        if (response.status === 200) {
            result = { ...successResult, data: {
                fileName: response.headers.get('Content-Disposition').split('filename=')[1],
                blob: await response.blob()
            }}
        } else {
            result = { ...errorResult, errorCode: response.errorCode }
        }
    } catch (e) {
        //console.error(e)
        result = errorResult
    }

    await requestDelay()

    return result
}
